import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';
import { usePanelAccess } from '../../context/PanelAccessContext';
import PanelHubGrid, { HubCardItem } from '../../components/PanelHubGrid';

const ALL_CARDS: (HubCardItem & { referentFunction?: string })[] = [
  { to: '/panel/users', title: 'Utilisateurs (détail)', description: 'Comptes, sanctions, historique.', accent: 'sky' },
  {
    to: '/panel/players/premium',
    title: 'Statut premium (joueurs)',
    description: 'Avantage jeu : premium, argents, médailles — pas un accès panel.',
    accent: 'emerald',
  },
  { to: '/panel/users-roles', title: 'Liste joueurs', description: 'Recherche et fiches rapides.', accent: 'sky' },
  { to: '/panel/moderation', title: 'Modération avancée', description: 'Déblocages que le modo seul ne peut pas faire.', accent: 'amber' },
  { to: '/panel/users/roles', title: 'Rôles & accès', description: 'Référent Admin : permissions utilisateurs.', accent: 'violet', referentFunction: 'Référent Admin' },
  { to: '/panel/roles/default-access', title: 'Accès panel (rôles)', description: 'Défauts des sections par rôle.', accent: 'violet' },
  { to: '/panel/system/security-logs', title: 'Logs sécurité', description: 'Traçabilité complète.', accent: 'emerald' },
  { to: '/panel/interventions/manage', title: 'Gestion scénarios', description: 'Scénarios et interventions CTA.', accent: 'cyan' },
  { to: '/panel/interventions/create', title: 'Créer scénario', description: 'Nouveau scénario d’appel.', accent: 'violet' },
];

const PanelAdminHubV1: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { loading, hasAccessToSection, hasReferentFunction } = usePanelAccess();
  const canEnterHub = hasAccessToSection('salon_admin');

  useEffect(() => {
    if (!loading && currentUser && !canEnterHub) {
      navigate('/panel/dashboard', { replace: true });
    }
  }, [loading, currentUser, canEnterHub, navigate]);

  const cards = useMemo(() => {
    return ALL_CARDS.filter((c) => {
      if (c.referentFunction) return hasReferentFunction(c.referentFunction);
      return true;
    });
  }, [hasReferentFunction]);

  if (!currentUser || loading || !canEnterHub) {
    return null;
  }

  return (
    <PanelHubGrid
      description="Administration : premium, économie, utilisateurs et déblocages au-dessus du niveau modérateur. Pas d’accès maintenance / config CM."
      cards={cards}
    />
  );
};

export default PanelAdminHubV1;
